module.exports = __webpack_public_path__ + "static/media/ImagineInternet_AUP_2019.8e78fcec.pdf";